/** @format */

import { createReducer, on } from '@ngrx/store';
import {
	addProductToCart,
	resetAddToCartSuccessInfo,
	resetAirballInfo,
	setAirballInfo,
	setATCFulfillmentOption,
	setFBTAirballInfo,
	setInventoryExceededStatus,
	setMaxOrMinQuantityAlert,
	setUserInputQuantity
} from './add-to-cart.actions';
import { AddToCartState } from '@pdp/data-access/interfaces';

export const atcFeatureKey = 'atc';

// declare what the values should be upon starting the application
export const initialAddToCartState: AddToCartState = {
	userInputQuantity: '1',
	fulfillmentOption: 'shipToMe',
	buttonAction: 'add to cart',
	success: null,
	// eslint-disable-next-line max-len
	airballMessage:
		"Your product missed the cart. We're sorry, please refresh your page and add to cart again. If the problem persists, please let us know.",
	isLoading: false,
	isMultipleProducts: false,
	inventoryExceededStatus: {
		inventoryExceeded: false
	},
	maxOrMinQuantityAlert: null
};

export const addToCartReducers = createReducer(
	initialAddToCartState,
	on(setUserInputQuantity, (state, action) => {
		return {
			...state,
			userInputQuantity: action.atcUserInputQuantity
		};
	}),
	on(setATCFulfillmentOption, (state, action) => {
		return {
			...state,
			fulfillmentOption: action.atcFulfillmentOption
		};
	}),
	on(setAirballInfo, resetAirballInfo, resetAddToCartSuccessInfo, (state, action) => {
		return {
			...state,
			success: action.success,
			isLoading: false,
			isMultipleProducts: false
		};
	}),
	on(setFBTAirballInfo, (state, action) => {
		return {
			...state,
			success: action.success,
			isLoading: false,
			isMultipleProducts: true
		};
	}),
	on(addProductToCart, (state) => {
		return {
			...state,
			isLoading: true
		};
	}),
	on(setInventoryExceededStatus, (state, action) => ({
		...state,
		inventoryExceededStatus: {
			...action
		}
	})),
	on(setMaxOrMinQuantityAlert, (state, action) => ({
		...state,
		maxOrMinQuantityAlert: action.message
	}))
);

// this is used for the AOT compiler because it cannot resolve that a function
// using the createReducer helper needs to be exported
// if we are using ivy we can use the reducer directly

// export function atcV3Reducer(state: State | undefined, action: Action) {
// 	return atcV3Reducers(state, action);
// }
// export function addToCartReducer(state, action) {
// 	return addToCartReducers(state, action);
// }
